// I would love to have a micro-library with just CSS<->LCH conversion and a
// color contrast function. I did find another "small-ish" library that has both
// of these functions, but it's actually larger than colord and tinycolor2
// combined.
import { colord, extend } from 'colord';
import lchPlugin from 'colord/plugins/lch';
import { readability } from 'tinycolor2';

extend([lchPlugin]);

/**
 * Return a new darkened color, suitable for contrast with white (`#fff`)
 *
 * @example
 * darkenColor("#f00");
 * darkenColor("#f00", { contrast: 4.5 });
 * darkenColor("#f00", { contrast: 4.5, minimumLightnessDistance: 10 });
 */
export function darkenColor(
  /** Base color in any format readable by colord */
  baseColor: string,
  {
    contrast = 4.5,
    minimumLightnessDistance = 0,
  }: {
    /** Actual range is 1-21, 3.0 and 4.5 are the WCAG levels */
    contrast?: number;

    /** Darken color by at least this much */
    minimumLightnessDistance?: number;
  } = {}
): string {
  // Color utils library was chopping off the `#` for us previously, if it was there.
  // ZapCard can get a data value that looks like this as the hex value : `417893`
  const colorToTransform = baseColor.startsWith('#')
    ? baseColor
    : `#${baseColor}`;
  // lightness, chroma, hue
  // https://async.zapier.com/p/56648/stop-making-boring-colors-switch-from-hsl-to-lch
  const color = colord(colorToTransform).toLch();
  const l = color.l;
  if (Number.isNaN(l)) {
    throw new Error(`couldn't parse color "${color}"`);
  }
  while (color.l > 0 && getContrast(colord(color).toHex()) < contrast) {
    color.l -= 1;
  }
  if (l - color.l < minimumLightnessDistance) {
    color.l = l - minimumLightnessDistance;
  }
  return colord(color).toHex();
}

function getContrast(color: string): number {
  const contrastColor = '#fffdf9';
  return readability(color, contrastColor);
}
